import { useDispatch, useSelector } from 'react-redux'
import { clearTypeOfAdditionalModal, selectCurrentShowTypeOfModal, setTypeOfAdditionalModal } from '../../../features/modal/modalSlice';
import { CloseIcon } from '../../../assets/icons/Svg';

export default function AddPackageModalHeader() {

    const dispatch = useDispatch()
    const typeOfModalShow = useSelector(selectCurrentShowTypeOfModal);
    
    const handleCloseStaffModal = () => {
        if(typeOfModalShow === 'newClient') {
            dispatch(clearTypeOfAdditionalModal())
            return
        } else {
            dispatch(setTypeOfAdditionalModal('updateClient'))
            return
        }
    }

    return (
        <div className=" bg-white">
            <div className="flex justify-between items-center py-1">
                <div className="items-start">
                    <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                        Select Package
                    </p>
                    <p className="text-sm text-slate-500">
                        Choose an available package to assign to the client.
                    </p>
                </div>
                <div className="flex justify-end items-center">
                    <button
                        type="button"
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                        onClick={handleCloseStaffModal}
                    >
                        <CloseIcon/>
                    </button>
                </div>
            </div>
        </div>
    )
}
